import bridge from "./bridge"

export const register = () => () => ({ store }) => {
  bridge.store = store
}
